import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_MAP } from 'app/core/helpers/api.map';
import { removeEmptyFields } from 'app/core/utils/object';
import { DataService } from 'app/shared/services/data.service';
import { RecaptchaService } from 'app/shared/services/preloaded-recaptcha-api.service';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { RegisterNewsletterModel } from '../models/register-news-letter.model';

@Injectable()
export class EmailSignupFormService {
  readonly #dataService = inject(DataService);
  readonly #recaptchaService = inject(RecaptchaService);

  registerNewsletter(params: RegisterNewsletterModel, lang?: string): Observable<{ status: number; data: object }> {
    return this.#recaptchaService.getRecaptchaToken('registerNewsletter').pipe(
      switchMap((token) => this.registerNewsletterWithToken(token, params, lang)),
      catchError((error) => throwError(error))
    );
  }

  private registerNewsletterWithToken(
    token: string,
    params: RegisterNewsletterModel,
    lang?: string
  ): Observable<{ status: number; data: object }> {
    const headers = { RecaptchaToken: token };
    return this.#dataService
      .post<{
        status: number;
        data: object;
      }>(API_MAP.sharedRegisterNewsletter, removeEmptyFields(params), headers)
      .pipe(
        map((data) => ({ status: 200, data })),
        catchError((error: HttpErrorResponse) => {
          return of({ status: error.status, data: error });
        })
      );
  }
}
